import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Ajustes() {
  const { user } = useAuth();
  const [nombre, setNombre]     = useState(localStorage.getItem('lf_clinicName') || 'Lady Fons');
  const [logo, setLogo]         = useState(localStorage.getItem('lf_clinicLogo') || '');
  const [pwdActual, setPwdActual] = useState('');
  const [pwdNueva, setPwdNueva]   = useState('');
  const [toast, setToast]         = useState('');
  const logoRef = useRef();

  const showToast = (msg) => { setToast(msg); setTimeout(()=>setToast(''), 3000); };

  // Preview topbar en tiempo real
  useEffect(() => {
    localStorage.setItem('lf_clinicName', nombre);
  }, [nombre]);

  const handleLogo = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      setLogo(ev.target.result);
      localStorage.setItem('lf_clinicLogo', ev.target.result);
      showToast('Logo actualizado');
    };
    reader.readAsDataURL(file);
  };

  const quitarLogo = () => {
    setLogo('');
    localStorage.removeItem('lf_clinicLogo');
    showToast('Logo eliminado');
  };

  const guardarNombre = () => {
    localStorage.setItem('lf_clinicName', nombre);
    showToast('Nombre actualizado');
  };

  const cambiarPassword = () => {
    if (!pwdActual || !pwdNueva) { showToast('Completa ambos campos'); return; }
    const users = JSON.parse(localStorage.getItem('lf_users') || '[]');
    const found = users.find(u => u.id === user.id);
    const currentPwd = found ? found.password : user.password;
    if (pwdActual !== currentPwd) { showToast('Contraseña actual incorrecta'); return; }
    const updated = users.map(u => u.id === user.id ? {...u, password: pwdNueva} : u);
    localStorage.setItem('lf_users', JSON.stringify(updated));
    setPwdActual(''); setPwdNueva('');
    showToast('Contraseña actualizada');
  };

  return (
    <div style={{ padding:'24px 24px 80px', fontFamily:"'Plus Jakarta Sans',sans-serif", maxWidth:640 }}>
      <h1 style={{ margin:'0 0 24px', fontSize:22, fontWeight:800, color:'#0f172a' }}>Ajustes del sistema</h1>

      {/* Card: Logo + Nombre */}
      <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 1px 3px rgba(0,0,0,0.08)', marginBottom:16 }}>

        {/* Preview topbar */}
        <p style={{ margin:'0 0 10px', fontSize:11, fontWeight:800, color:'#94a3b8', textTransform:'uppercase', letterSpacing:1 }}>Preview barra superior</p>
        <div style={{ background:'#185fa5', borderRadius:10, padding:'12px 18px', display:'flex', alignItems:'center', gap:12, marginBottom:24 }}>
          {logo
            ? <img src={logo} alt="logo" style={{ width:36, height:36, borderRadius:18, objectFit:'cover', border:'2px solid rgba(255,255,255,0.55)' }} />
            : <div style={{ width:36, height:36, borderRadius:18, background:'rgba(255,255,255,0.25)', border:'2px solid rgba(255,255,255,0.55)', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontWeight:800, fontSize:16 }}>L</div>
          }
          <span style={{ color:'#fff', fontWeight:800, fontSize:16 }}>{nombre || 'Lady Fons'}</span>
        </div>

        {/* Logo upload */}
        <p style={{ margin:'0 0 8px', fontSize:11, fontWeight:800, color:'#94a3b8', textTransform:'uppercase', letterSpacing:1 }}>Imagen / Logo (aparece en barra superior)</p>
        <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:20 }}>
          <div style={{ width:64, height:64, borderRadius:32, background:'#f1f5f9', border:'2px dashed #cbd5e1', overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
            {logo
              ? <img src={logo} alt="logo" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
              : <span style={{ fontSize:24 }}>🏷️</span>
            }
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            <input ref={logoRef} type="file" accept="image/*" onChange={handleLogo} style={{ display:'none' }} />
            <button onClick={() => logoRef.current.click()}
              style={{ padding:'8px 16px', background:'#fef9c3', color:'#854d0e', border:'1px solid #fde68a', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700 }}>
              📁 Subir imagen
            </button>
            {logo && (
              <button onClick={quitarLogo}
                style={{ padding:'8px 16px', background:'#fee2e2', color:'#dc2626', border:'1px solid #fecaca', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700 }}>
                Quitar logo
              </button>
            )}
          </div>
        </div>

        {/* Nombre */}
        <p style={{ margin:'0 0 6px', fontSize:11, fontWeight:800, color:'#94a3b8', textTransform:'uppercase', letterSpacing:1 }}>Nombre de la empresa</p>
        <div style={{ display:'flex', gap:10 }}>
          <input value={nombre} onChange={e=>setNombre(e.target.value)}
            style={{ flex:1, padding:'10px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:13, outline:'none' }} />
          <button onClick={guardarNombre}
            style={{ padding:'10px 20px', background:'#185fa5', color:'#fff', border:'none', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700 }}>
            Guardar
          </button>
        </div>
      </div>

      {/* Card: Cambiar contraseña */}
      <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 1px 3px rgba(0,0,0,0.08)' }}>
        <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:800, color:'#0f172a' }}>🔑 Cambiar contraseña</h3>
        {[['Contraseña actual', pwdActual, setPwdActual],['Nueva contraseña', pwdNueva, setPwdNueva]].map(([label,val,set]) => (
          <div key={label} style={{ marginBottom:14 }}>
            <label style={{ display:'block', fontSize:11, fontWeight:800, color:'#94a3b8', marginBottom:5, textTransform:'uppercase', letterSpacing:0.5 }}>{label}</label>
            <input type="password" value={val} onChange={e=>set(e.target.value)}
              style={{ width:'100%', padding:'10px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:13, outline:'none', boxSizing:'border-box' }} />
          </div>
        ))}
        <button onClick={cambiarPassword}
          style={{ padding:'10px 20px', background:'#185fa5', color:'#fff', border:'none', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700 }}>
          Actualizar contraseña
        </button>
      </div>

      {toast && (
        <div style={{ position:'fixed', bottom:60, left:'50%', transform:'translateX(-50%)', background:'#0f172a', color:'#fff', padding:'10px 20px', borderRadius:10, fontSize:13, fontWeight:600, zIndex:999, whiteSpace:'nowrap' }}>
          {toast}
        </div>
      )}
    </div>
  );
}
